<template>
  <default-dialog ref="dialog" persistent>
    <div class="general-error">
      <div>
        <lottie-player
          :src="JSON.stringify(require('@/assets/animations/meh-smiley.json'))"
          style="width: 90px; height: 90px"
          autoplay/>
      </div>

      <div class="r-image-headline error-headline">יש בעיה...</div>

      <div class="r-text-regular text">
        <div>אל דאגה, אנחנו על זה!</div>
        <div>בכל מקרה, אפשר ללחוץ כאן ולכתוב לנו.</div>
      </div>
      <dialog-button label="לפניה לצוות" @click="sendMailTo('saving@riseup.co.il')" />
    </div>
  </default-dialog>
</template>

<script>
import GlobalDialog from '@/components/base/GlobalDialog';
import DefaultDialog from '@/components/styled/DefaultDialog';
import DialogButton from '@/components/styled/DialogButton';
import ExternalPagesActions from '@/mixins/ExternalPagesActions';

export default {
  name: 'GeneralError',
  components: { DialogButton, DefaultDialog },
  mixins: [GlobalDialog, ExternalPagesActions],
};
</script>

<style scoped lang="scss">

.general-error {

  margin-bottom: 16px;

  .error-headline {
    margin: 20px 0;
  }

  .text {
      margin-bottom: 16px;
  }

  .error-avatar {
    $radius: 81px;
    height: $radius;
    width: $radius;
  }
}

</style>
